'use client';
import { objectValues } from '@s7/utils';

/**
 * Определяет, вставлен ли скрипт аналитики на страницу.
 * Используется для предотвращения повторной инициализации.
 * */ var isScriptInjected = function(scriptSource) {
    var scripts = document.querySelectorAll("script[src]");
    var regex = new RegExp("^" + scriptSource);
    return Boolean(objectValues(scripts).filter(function(value) {
        return regex.test(value.src);
    }).length);
};

export { isScriptInjected };
